import { loginByUsername, loginByPasswordToken, logout, getUserInfo } from '@/api/login'
import PageView from '@/layouts/PageView'
import { getAccessMenu } from '@/api/userRequest.js'
import router from '@/router/lazy'
import { removeToken } from '@/utils/auth'
import { generaMenu } from '@/utils/handlerMenu'
import RsaEncrypt from '@/utils/RsaEncrypt'
import { constantRouterMap } from '../.././router/lazy'

const user = {
  state: {
    userInfo: '',
    passwordToken: '',
    loginName: sessionStorage.getItem('loginName'),
    sessionId: '',
    authTenants: [],
    authDepartments: [],
    currentLoginTenant: {},
    currentLoginDepartment: {},
    systemAuths: [],
    clickMenu: '',
    keyPathMap: {}
  },
  mutations: {
    KEY_PATH_MAP: (state, keyPathMap) => {
      state.keyPathMap = keyPathMap
    },
    CURRENT_CLICK_MENU: (state, clickMenu) => {
      state.clickMenu = clickMenu
    },
    SET_PASSWORD_TOKEN: (state, passwordToken) => {
      state.passwordToken = passwordToken
    },
    SET_LOGIN_NAME: (state, loginName) => {
      state.loginName = loginName
    },
    SET_SESSION_ID: (state, sessionId) => {
      state.sessionId = sessionId
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
    },
    SET_AUTH_TENANTS: (state, authTenants) => {
      state.authTenants = authTenants
    },
    SET_AUTH_DEPARTMENTS: (state, authDepartments) => {
      state.authDepartments = authDepartments
    },
    SET_LOGIN_DEPARTMENT: (state, currentLoginDepartment) => {
      state.currentLoginDepartment = currentLoginDepartment
    },
    SET_LOGIN_TENANT: (state, currentLoginTenant) => {
      state.currentLoginTenant = currentLoginTenant
    },
    SET_SYSTEM_AUTHS: (state, systemAuths) => {
      state.systemAuths = systemAuths
    }
  },
  actions: {
    initUserInfo ({ commit }) {
      commit('SET_USER_INFO', '')
    },
    // 用户名登录
    LoginByUsername ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        commit('SET_USER_INFO', '')
        RsaEncrypt(userInfo.password, (res) => {
          let password = res
          const rememberPassword = userInfo.rememberPassword
          const loginParams = {
            loginName: userInfo.loginName,
            password: password,
            rememberPassword: rememberPassword
          }
          loginByUsername(loginParams).then(response => {
            commit('SET_LOGIN_NAME', response.data.data.loginEmployee.loginName)
            sessionStorage.setItem('loginName', response.data.data.loginEmployee.loginName)
            commit('SET_SESSION_ID', response.data.data.loginEmployee.sessionId)
            sessionStorage.setItem('sessionId', response.data.data.loginEmployee.sessionId)
            if (rememberPassword && response.data.data.passwordToken) {
              commit('SET_PASSWORD_TOKEN', response.data.data.passwordToken)
              sessionStorage.setItem('passwordToken', response.data.data.passwordToken)
            }
            resolve()
          }).catch(error => {
            console.log('login error')
            reject(error)
          })
        })
      })
    },
    // Token登录
    LoginByPasswordToken ({ commit }, passwordToken) {
      return new Promise((resolve, reject) => {
        commit('SET_USER_INFO', '')
        const loginParams = {
          passwordToken: passwordToken,
          loginName: sessionStorage.getItem('loginName'),
          sessionId: sessionStorage.getItem('sessionId')
        }
        loginByPasswordToken(loginParams).then(response => {
          commit('SET_PASSWORD_TOKEN', response.data.data.passwordToken)
          commit('SET_LOGIN_NAME', response.data.data.loginEmployee.loginName)
          commit('SET_SESSION_ID', response.data.data.loginEmployee.sessionId)
          sessionStorage.setItem('passwordToken', response.data.data.passwordToken)
          sessionStorage.setItem('loginName', response.data.data.loginEmployee.loginName)
          sessionStorage.setItem('sessionId', response.data.data.loginEmployee.sessionId)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetUserInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(response => {
          if (response.data.data) {
            const userInfo = response.data.data
            const authTenants = response.data.data.authTenants
            const authDepartments = response.data.data.loginTenant.authDepartments
            const currentLoginTenant = {
              tenantId: response.data.data.loginTenant.tenantId,
              tenantName: response.data.data.loginTenant.tenantName
            }
            const currentLoginDepartment = {
              departmentId: response.data.data.loginTenant.loginDepartment.departmentId,
              departmentName: response.data.data.loginTenant.loginDepartment.departmentName,
              departmentSystemAuths: response.data.data.loginTenant.loginDepartment.systemAuths
            }
            commit('SET_LOGIN_NAME', response.data.data.loginName)
            commit('SET_USER_INFO', userInfo)
            commit('SET_AUTH_TENANTS', authTenants)
            commit('SET_AUTH_DEPARTMENTS', authDepartments)
            commit('SET_LOGIN_DEPARTMENT', currentLoginDepartment)
            commit('SET_LOGIN_TENANT', currentLoginTenant)
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 前端 登出
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        removeToken()
        sessionStorage.removeItem('passwordToken')
        sessionStorage.removeItem('loginName')
        sessionStorage.removeItem('sessionId')
        resolve()
      })
    },
    // 登出
    LogOut ({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_USER_INFO', '')
        logout().then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 处理系统菜单（一级菜单）
    GenerateRoutes ({ commit }, systemAuths) {
      return new Promise(resolve => {
        let routes = []
        let routeArr = constantRouterMap()
        if (systemAuths) {
          systemAuths.forEach(item => {
            // alert(JSON.stringify(item))
            const menu = {
              path: (item.systemUrl === undefined || item.systemUrl === '')
                ? ('/' + (item.systemAuthId.toString() + Math.ceil(Math.random() * 100).toString())) : item.systemUrl,
              component: PageView,
              children: [],
              icon: item.systemIcon,
              name: item.authName,
              meta: {
                isSystem: true,
                authKey: item.authKey,
                systemAuthId: item.systemAuthId,
                systemType: item.systemType
              }
            }
            routes.push(menu)
          })
          let addRouteArr = []
          for (let i = 0; i < routeArr.length; i++) {
            if (routeArr[i].path === '/') {
              let arr = routeArr[i].children.concat(routes)
              routeArr[i].children = arr
              addRouteArr.push(routeArr[i])
              break
            }
          }
          commit('SET_SYSTEM_AUTHS', routeArr)
          resolve(addRouteArr)
        } else {
          commit('SET_SYSTEM_AUTHS', routeArr)
          resolve(routes)
        }
      })
    },
    initClickMenu ({ commit }) {
      commit('CURRENT_CLICK_MENU', '')
    },
    // 点击系统菜单时，更新系统下的子菜单
    async fillChildMenuOnSystemClick ({ commit, state, dispatch }, meta) {
      // let keyPathMap = new Map()
      // const permissions = store.state.user
      // 防止用户重复点击
      commit('CURRENT_CLICK_MENU', meta.authKey)
      let routes = state.systemAuths
      if (meta && meta.isSystem) {
        for (let i = 0; i < routes.length; i++) {
          if (routes[i].path === '/') {
            for (let j = 0; j < routes[i].children.length; j++) {
              if (routes[i].children[j].meta && routes[i].children[j].meta.authKey &&
                routes[i].children[j].meta.authKey === meta.authKey) {
                if (routes[i].children[j].children && routes[i].children[j].children.length !== 0) {
                  return
                } else {
                  // 查询系统菜单
                  let res = await getAccessMenu(meta.authKey)
                  generaMenu(routes[i].children[j].children, res.data.data)
                  // buildInvisiblePageRouter(routes[i].children, permissions, keyPathMap)
                  // commit('KEY_PATH_MAP', keyPathMap)
                  commit('SET_SYSTEM_AUTHS', routes)
                  let routArr = []
                  routArr.push(routes[i])
                  router.addRoutes(routArr)
                }
                break
              }
            }
            break
          }
        }
      }
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js